import { contextualViewForId, contextualViewsForPrimary } from "../knowledge/navigationModel.js";
import { LucideIcon } from "./lucideIconMap.js";

export function ContextSubnav({ activePrimary, activeViewId, onSelectView }) {
  const views = contextualViewsForPrimary(activePrimary);
  const activeView = contextualViewForId(activeViewId);

  function handleKeyDown(event, index) {
    if (!["ArrowLeft", "ArrowRight", "Home", "End"].includes(event.key)) return;
    event.preventDefault();
    const lastIndex = views.length - 1;
    const nextIndex =
      event.key === "Home"
        ? 0
        : event.key === "End"
          ? lastIndex
          : event.key === "ArrowLeft"
            ? (index - 1 + views.length) % views.length
            : (index + 1) % views.length;
    onSelectView(views[nextIndex].id);
  }

  return (
    <div className="context-strip" aria-label="Workspace sections">
      <div className="context-title">
        <span>{activePrimary?.type === "domain" ? "Domain workspace" : "Operations workspace"}</span>
        <strong>{activePrimary?.label ?? activeView.label}</strong>
      </div>
      <div className="context-tabs" role="tablist" aria-label={`${activePrimary?.label ?? "Strategy"} sections`}>
        {views.map((view, index) => (
          <button
            key={view.id}
            role="tab"
            aria-selected={view.id === activeViewId}
            tabIndex={view.id === activeViewId ? 0 : -1}
            className={view.id === activeViewId ? "active" : ""}
            onClick={() => onSelectView(view.id)}
            onKeyDown={(event) => handleKeyDown(event, index)}
            title={view.description}
          >
            <LucideIcon name={view.icon} size={15} />
            {view.label}
          </button>
        ))}
      </div>
    </div>
  );
}
